module.exports = __webpack_public_path__ + "static/media/carousal_1.a7a46d9a.png";